// extracted by mini-css-extract-plugin
module.exports = {"ArrowPagination":"_3UHMTTCj","arrow":"_23hdXs3M","arrowDisabled":"_3nbbpjX2"};